export function flattenRoutes(routes) {
    const result = [];

    routes.forEach(route => {
        const { element, title, path, index, children } = route;

        if (path || index) {
            result.push({ path, index, title });
        }

        if (children) {
            result.push(...flattenRoutes(children));
        }
    });

    return result;
}